import { useNavigate, useParams } from 'react-router-dom';

import Page from '@/components/layout/Page';
import Loader from '@/components/common/Loader';
import Error from '@/components/common/Error';
import HeaderWithBack from '@/components/common/HeaderWithBack';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

import { useCoachSelf } from '@/data/coach';

import EditImages from './components/profile/EditImages';
import ProfileForm from './components/profile/ProfileForm';

const EditCoachProfileApplicationPage = () => {
  const coach = useCoachSelf();
  const navigate = useNavigate();
  const params = useParams();

  const handleEditSuccess = async () => {
    navigate(`/application/${params.coachActivityId}`);
  };

  if (coach.isLoading && !coach.data) {
    return (
      <Page>
        <HeaderWithBack
          to={`/application/${params.coachActivityId}`}
          title="Application"
        />
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <Loader />
        </div>
      </Page>
    );
  }

  if (coach.error) {
    return (
      <Page>
        <HeaderWithBack
          to={`/application/${params.coachActivityId}`}
          title="Application"
        />
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <Error error="There was an error loading coach profile" />
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <HeaderWithBack
        to={`/application/${params.coachActivityId}`}
        title="Application"
      />
      <Card>
        <CardHeader>
          <CardTitle>
            {coach.data.user.firstname} {coach.data.user.lastname}
          </CardTitle>
        </CardHeader>
        <EditImages />
        <CardContent>
          <ProfileForm onSuccess={handleEditSuccess} />
        </CardContent>
      </Card>
      <div className="flex justify-center py-8"></div>
    </Page>
  );
};

export default EditCoachProfileApplicationPage;
